import type {MembershipApiModel} from '../../../api/membership';
import type {AsyncStrategy} from '../utils';

import {membershipStore} from '../../../api/membership';
import {isIamCoach} from '../../../utils/entity/isIamCoach';
import {AppError} from '../../../utils/errors/app';
import {logger} from '../../../utils/logger';
import {isCancelCommand} from '../utils';
import {membershipsDeclineRequestedReasonConfirm} from './membershipDeclineRequestedReasonConfirm';

type Config = {
  isIndividualProgram: boolean;
  memberships: MembershipApiModel[];
};

export {membershipDeclineRequested};

const strategy: AsyncStrategy<Config> = async (roles, config) => {
  if (isIamCoach()) {
    return roles.coach(config);
  } else {
    return roles.client(config);
  }
};

async function membershipDeclineRequested(config: Config) {
  return strategy({client: asClient, coach: asCoach}, config);
}

membershipDeclineRequested.asCoach = asCoach;
membershipDeclineRequested.asClient = asClient;

async function asClient(_config: Config) {
  throw new AppError('not_allowed');
}

async function asCoach({isIndividualProgram, memberships}: Config) {
  const confirmResult = await membershipsDeclineRequestedReasonConfirm({
    isIndividualProgram,
  });

  if (isCancelCommand(confirmResult)) {
    return;
  }

  try {
    await membershipStore.declineBatch(
      memberships.map(membership => ({
        membership,
        params: {decline_reason: confirmResult.reason || null},
      })),
    );
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
